import React from 'react'
import '../AdminPanel/adminpanel.css'
import { Outlet } from 'react-router-dom'
import AdminNavbar from '../AdminNavbar/AdminNavbar'

const AdminPanel = () => {
  return (
    <div className='adminpanel_container'>
      <AdminNavbar/>
        <Outlet/>
    </div>
  )
}

export default AdminPanel